export var Method;
(function (Method) {
    Method["Post"] = "POST";
    Method["Get"] = "GET";
    Method["Put"] = "PUT";
    Method["Patch"] = "PATCH";
    Method["Delete"] = "DELETE";
})(Method || (Method = {}));
//# sourceMappingURL=method.js.map